import { createAction } from '@reduxjs/toolkit';

export const fetchMemberFavourites = createAction('memberFavourites/FETCH_MEMBER_FAVOURITES');
export const addMemberFavourite = createAction('memberFavourites/ADD_MEMBER_FAVOURITE');
export const removeMemberFavourite = createAction('memberFavourites/REMOVE_MEMBER_FAVOURITE');

export const clearMemberFavourites = createAction('memberFavourites/CLEAR_MEMBER_FAVOURITES');
export const setMemberFavourites = createAction('memberFavourites/SET_MEMBER_FAVOURITES');
export const setMemberFavouriteError = createAction('memberFavourites/SET_MEMBER_FAVOURITE_ERROR');
